<div
  [hidden]="dataSource.data?.length"
  class="row center">
  <div class="col">
    <h2>{{ "toolhistory.norecords" | translate }}</h2>
  </div>
</div>
<div
  [hidden]="!dataSource.data?.length"
  id="history-details"
  class="col bg-white u-shadow u-scroll--horizontal">
  <div
    id="tool-history-table"
    class="tools-history-table col">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="c-table c-table--expandable">
      <ng-container matColumnDef="raNumber">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef>
          {{ "toolhistory.workorder" | translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let ra"
          class="c-clickable"
          [ngClass]="{ 'c-clickable': ra.events?.length }"
          (click)="onEventGroupClick(ra)"
          colspan="4"
          class="c-table__group-header"
          [class.is-toggled]="ra.expanded">
          <i
            *ngIf="ra.events?.length"
            class="c-icon c-icon--toggle"></i>
          <span class="tool-history-workshop-title">
            {{ ra.flowType | translate }}:
            {{ !ra.hasAnyDummyEquipmentEvent ? ra.raNumber : "" }}
            <a
              *ngIf="ra.hasAnyDummyEquipmentEvent"
              target="_blank"
              routerLink="{{ ra.linkToFieldServiceJob }}"
              >{{ ra.raNumber }}</a
            >({{ ra.startDate | date: "dd.MM.yyyy" }})
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="toolEventsDetail">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let ra"
          class="expandable-row-detail-cell">
          <div [@detailExpand]="ra.expanded ? 'expanded' : 'collapsed'">
            <table
              #expandedRowDetailTable
              mat-table
              matSort
              #nestedMatSort="matSort"
              [dataSource]="getEventsDataSource(ra.events, nestedMatSort)"
              class="detail-table">
              <ng-container matColumnDef="name">
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  width="25%">
                  {{ "toolhistory.event" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let event"
                  width="25%">
                  {{ event.name | titlecase }}
                </td>
              </ng-container>

              <ng-container matColumnDef="date">
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  width="25%">
                  {{ "toolhistory.completed" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let event"
                  width="25%">
                  {{ event.date | date }}
                </td>
              </ng-container>

              <ng-container matColumnDef="docs">
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  width="25%">
                  {{ "toolhistory.documentation" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let event"
                  width="25%">
                  <span
                    class="c-download-link"
                    *ngFor="let doc of event.docs">
                    <download-file [file]="doc"></download-file>
                  </span>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="['name', 'date', 'docs']"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: ['name', 'date', 'docs']"></tr>
            </table>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="['raNumber']"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['raNumber']"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['toolEventsDetail']; when: isExpansionDetailRow"
        class="expandable-row"
        [class.expanded-row]="row.expanded"></tr>
    </table>
  </div>
  <div class="col-12">
    <mat-paginator
      [showFirstLastButtons]="true"
      [pageSize]="10"
      [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
  </div>
</div>
